import { Component } from '@angular/core';
import { Color } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { ModalWorkflowService } from '@lsq-frontend/common-ui';

@Component({
    selector: 'mfa-confirmation-modal',
    template: ` <div class="modal-content confirmation">
        <div class="modal-header" [style.padding-top]="'3rem'">
            <h2 i18n>New Device Added</h2>
            <lsq-button
                appearance="transparent"
                class="close"
                ariaLabel="Close"
                i18n-ariaLabel
                (buttonClick)="modalWorkflowService.hideWorkflow()"
            >
                <lsq-icon aria-hidden="true" [type]="icons.Close" [color]="colors.Black">
                </lsq-icon>
            </lsq-button>
        </div>
        <div class="modal-body">
            <p class="body">
                Your new device has been successfully enrolled in Multi-Factor Authentication. A
                confirmation of this action has been sent via email.
            </p>
        </div>
        <div class="modal-footer">
            <lsq-button
                i18n
                size="sm"
                type="button"
                appearance="primary"
                (buttonClick)="modalWorkflowService.hideWorkflow()"
            >
                Close
            </lsq-button>
        </div>
    </div>`,
    styleUrls: ['./mfa-confirmation-modal.component.scss']
})
export class MfaConfirmationModalComponent {
    public readonly icons = Icons;
    public readonly colors = Color;
    constructor(public modalWorkflowService: ModalWorkflowService) {}
}
